/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { localize } from 'commons/LocalizedText/LocalizedText';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { IconButton, TextField } from '@material-ui/core';
import { CustomTable } from 'commons/Table/CustomTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { generateRow } from 'utils/helpers/RowHelper';
import { TechnicalItemType } from 'components/TechnicalItemType/TechnicalItemType';


const useStyles = makeStyles((theme) => ({
  header: {
    cursor: 'pointer',
    backgroundColor: theme.palette.primary.light,
    padding: '20px 20px !important'
  },
  label:{
    color: theme.palette.primary.main,
    fontSize: '18px',
    textTransform: 'uppercase',
    fontWeight:"bold"
  },
  technicalValueNumber: {
    color: 'black',
    fontWeight:"bold"
  },
  openIcon: {
    color: theme.palette.primary.main
  }
}));

export const ProductTestTestedPoint = ({ testedPoint, handleOpenTestedPoints }) => {
  const classes = useStyles();

  const handleIsOpen = applicationRecid => {
    handleOpenTestedPoints(applicationRecid);
  }

  const productTestTechnicalItemRows = [
    generateRow({
      name: 'itemType',
      width: '10%',
      mobileWidth: '40%',
      isSortable: false,
      template: (row) => (
        <TechnicalItemType type={row.technicalItem.technicalItemType}/>
      )
    }),
    generateRow({
      name: 'technicalItem',
      width: '10%',
      mobileWidth: '40%',
      isSortable: false,
      template: (row) => (
        <div>
          {row.technicalItem.label}
        </div>
      )
    }),
    generateRow({
      name: 'measureUnit',
      width: '10%',
      mobileWidth: '40%',
      isSortable: false,
      template: (row) => (
        <div>
          {row.technicalItem.measureUnit}
        </div>
      )
    }),
    generateRow({
      name: 'valueType',
      width: '10%',
      mobileWidth: '40%',
      isSortable: false,
      template: (row) => (
        <div>
          {row.technicalItem.valueType.text}
        </div>
      )
    }),
    generateRow({
      name: 'declaredValue',
      width: '10%',
      mobileWidth: '40%',
      isSortable: false,
      template: (row) => (
        <div>
          {row.technicalValueForLaboGrid.declaredValue?.itemValue ?? '-'}
        </div>
      )
    }),
    generateRow({
      name: 'measuredValue',
      width: '10%',
      mobileWidth: '40%',
      isSortable: false,
      template: (row) => (
        <div>
          <TextField disabled value={row.technicalValueForLaboGrid.measuredValue?.itemValue} variant="outlined"/>
        </div>
      )
    })
  ];

  return (
    <Grid container direction='column' spacing={2}>
      <Grid className={classes.header} item onClick={() => {handleIsOpen(testedPoint.application.recid)}}>
        <Grid container justifyContent='space-between'>
          <Grid item>
            <Grid alignItems='center' container spacing={1}>
              <Grid className={classes.label} item>
                {testedPoint.application.label}
              </Grid>
              <Grid className={classes.technicalValueNumber} item>
                {`[${testedPoint.technicalValues.length} ${localize('technicalItems')}]`}
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <IconButton
              className={classes.openIcon}
              onClick={() => {handleIsOpen(testedPoint.application.recid)}}
              size="small"
            >
              <FontAwesomeIcon icon={testedPoint.isOpen ? faChevronUp : faChevronDown} />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
      {testedPoint.isOpen && (
        <Grid item>
          <Grid container direction='column'>
            <CustomTable
              headers={productTestTechnicalItemRows}
              isBackend={false}
              needForFooter={false}
              rowKey="technicalItemRow"
              rows={testedPoint.technicalValues}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};